import { createEmailTemplate } from "./create-email-template";
import { deleteEmailTemplate } from "./delete-email-template";
import { deleteOriginTemplateFromTeam } from "./delete-origin-template-from-team";
import { getAiEmailPreviewSuggestions } from "./get-ai-email-preview-suggestions";
import { getAiSubjectLineSuggestions } from "./get-ai-subject-line-suggestions";
import { getEmailTemplate } from "./get-email-template";
import { getEmailTemplateClickTrackingData } from "./get-email-template-click-tracking-data";
import { getEmailTemplateNames } from "./get-email-template-names";
import { getEmailTemplates } from "./get-email-templates";
import { getEmailTemplatesByTeam } from "./get-email-templates-by-team";
import { getFavoritesEmail } from "./get-favorites-email";
import { getOriginEmailTemplates } from "./get-origin-email-templates";
import { listPreviewEvents } from "./list-preview-events";
import { paginateEmailTemplates } from "./paginate-email-templates";
import { previewEmailTemplate } from "./preview-email-template";
import { sendTestEmail } from "./send-test-email";
import { updateEmailTemplate } from "./update-email-template";

export const emailTemplateSchema = {
  deleteEmailTemplate,
  deleteOriginTemplateFromTeam,
  previewEmailTemplate,
  getEmailTemplate,
  getEmailTemplates,
  getOriginEmailTemplates,
  getEmailTemplatesByTeam,
  getEmailTemplateClickTrackingData,
  paginateEmailTemplates,
  getFavoritesEmail,
  getEmailTemplateNames,
  listPreviewEvents,
  sendTestEmail,
  getAiSubjectLineSuggestions,
  getAiEmailPreviewSuggestions,
  updateEmailTemplate,
  createEmailTemplate,
};
